import { useAvailabilityStore } from '@/service/state/Availability/useAvailabilityStore';
import { cn } from '@/service/utils/cn';

type TTipsProps = {
    clearBackError: () => void;
    tipsList: number[];
};

export const Tips = ({ tipsList, clearBackError }: TTipsProps) => {
    const { gratuity, isCustom, selectGratuity } = useAvailabilityStore(
        ({ gratuity, isCustom, selectGratuity }) => ({ gratuity, isCustom, selectGratuity })
    );

    return (
        <>
            <div className="tx-large-medium grid grid-cols-2 gap-2 text-gray-2 dark:text-gray-3 md:grid-cols-4 md:gap-3">
                {tipsList.map((percent) => {
                    return (
                        <button
                            key={percent}
                            type="button"
                            className={cn(
                                'flex h-[52px] w-full items-center justify-center rounded-[21px] border md:h-[56px]',
                                !isCustom && percent === gratuity
                                    ? 'border-none bg-gradient-blue text-white'
                                    : 'border-gray-3 hover:border-blue-2 dark:border-dark-1 dark:hover:border-blue-2'
                            )}
                            onClick={() => {
                                selectGratuity(percent);
                                clearBackError();
                            }}
                            data-test-id={`tip-btn-${percent}`}
                        >
                            {percent}%
                        </button>
                    );
                })}
                <button
                    type="button"
                    className={cn(
                        'flex h-[52px] w-full items-center justify-center rounded-[21px] border md:h-[56px]',
                        !isCustom && gratuity === 0
                            ? 'border-none bg-red-8 text-white'
                            : 'border-gray-3 hover:border-blue-2 dark:border-dark-1 dark:hover:border-blue-2'
                    )}
                    onClick={() => {
                        selectGratuity(0);
                        clearBackError();
                    }}
                    data-test-id="tip-btn-none"
                >
                    None
                </button>
            </div>
            <input
                className={cn(
                    'tx-large-medium relative mt-3 h-9 w-full rounded-[50px] border border-gray-3 bg-transparent py-0 pl-[30px] pr-[25px] text-base text-gray-1 outline-none dark:border-dark-1 dark:text-gray-3 md:mt-3 md:h-12',
                    isCustom
                        ? 'border-blue-2 before:h-2 before:w-2 after:absolute after:left-0 after:content-["$"] dark:border-blue-2'
                        : 'before:content-[""]'
                )}
                placeholder="$ Enter Custom Tip Amount"
                value={isCustom ? `$${gratuity}` : ''}
                onChange={(newValue) => {
                    selectGratuity(newValue.target.value.replace(/\$/g, ''), true);
                    clearBackError();
                }}
                data-test-id="tips-input"
            />
        </>
    );
};
